module.exports = __webpack_public_path__ + "prod/1.42.2/media/construction.988984e6.mp4";